const profileKeys = {
  /**
   * All profiles and associated reward balances
   */
  base: ["profiles"] as const,
  details: () => [...profileKeys.base, "detail"] as const,
  /**
   * A single profile, either the current user or viewed using a given id
   */
  detail: (id?: string) => [...profileKeys.details(), id] as const,
  /**
   * A single user's reward balance, either the current user or viewed using a given id
   */
  balance: (id?: string) => [...profileKeys.detail(id), "balance"] as const,
};

const rewardKeys = {
  base: ["rewards"] as const,
  details: () => [...rewardKeys.base, "detail"] as const,
  detail: (id: string) => [...rewardKeys.details(), id] as const,
};

export { profileKeys, rewardKeys };
